<template>
<div>
  <div class="container" v-if="isProvPriv==1 && isShow">
    <div class="pg-pd12">
      <!-- 通知栏2 -->
      <div class="notice-box1">
        <div class="left-text line_right">公告</div>
        <div class="swiper-box">
          <annoswiper :dataList="noticeInfo"></annoswiper>
        </div>
      </div>

      <div class="prov-total">
        <div class="prov-total-sel">
          <div class="select" @click="showQuarter()">
            <span>{{quarterName}}</span>
            <div class="select-icon"></div>
          </div>
        </div>
        <div class="content" v-if="ranking.length>0">
          <div class="content-pd16">
            <tab class="mt0" ref="drawer" :tabList="dataTab" :name="'dataTab'" @onSwitch="tabSwitch"></tab>
              <rankCharts class="mt16" :rankList="ranking" @navToDetail="navToDetail" :checked="checked" />
          </div>
        </div>

            <template v-else>
              <!-- 没有数据提示 -->
            <div class="noData-bg">
              <nodata :noData="noData"></nodata>
            </div>
            </template>
      </div>

    </div>
    <common-picker ref="commonPickerQuarter" :typeList="newQuarterList" :cols="cols1" @getTypeValue="getQuarterValue">
    </common-picker>
  </div>
  <template  v-if="isProvPriv==0 && isShow">
    <provincialDetail></provincialDetail>
  </template>
    </div>
</template>
<script>
    import nodata from './components/nodata';// 没有数据
    import rankCharts from './components/RankCharts';
    import tab from 'comps/tab';
    import commonPicker from '../../components/base/commonPicker'
    import annoswiper from './components/anno-swiper'
    import provincialDetail from './provincialDetail'
    import api from '../../service/modules/appraise';
    export default {
        components: {
            // scoreCard,
            tab,
            rankCharts,
            commonPicker,
            annoswiper,
            provincialDetail,
            nodata
        },

        data () {
            return {
                noData: {
                    title: '暂无数据'
                },
                checked: true,
                ranking: [],
                year: '2019',
                quarter: '2',
                quarterName: '',
                code: '',
                newQuarterList: [],
                quarterList: [],
                noticeInfo: [],
                cols1: 1,
                dataTab: ['一类地区', '二类地区'],
                rankList: [],
                yearAndQuarterList: [],
                yearQuarter: '',
                annoList: [],
                isProvPriv: 0,
                tabIndex: 0,
                complainQuarter: '',
                isShow: false,
                compickFlag2: false,
                compickFlag: false

            }
        },

        computed: {},

        watch: {},

        methods: {
            navToDetail (val) {
                let data = {
                    year: this.year,
                    quarter: this.quarter,
                    isProvPriv: this.isProvPriv,
                    area: val.area,
                    areaName: val.areaName,
                    quarterName: this.quarterName,
                    complainQuarter: this.complainQuarter,
                    compickFlag2: this.compickFlag2,
                    compickFlag: this.compickFlag
                }
                console.log('-----------------------------------');
                console.log(this.quarterName);
                this.$router.push({
                    path: '/appraise/provincialDetail',
                    query: {
                        year: this.year,
                        quarter: this.quarter,
                        isProvPriv: this.isProvPriv,
                        area: val.area,
                        areaName: val.areaName,
                        quarterName: this.quarterName,
                        complainQuarter: this.complainQuarter,
                        compickFlag2: this.compickFlag2,
                        compickFlag: this.compickFlag
                    }
                });
            },
            // 公告
            getNotice () {
                this.isShow = false
                api.getMainAssessInfo().then(res => {
                    if (res.ret === 0) {
                        this.noticeInfo = res.data.noticeInfo
                        this.yearAndQuarterList = res.data.yearAndQuarterList // 季度列表
                        this.isProvPriv = res.data.isProvPriv
                        this.isShow = true
                        let arr = [];
                        // 提取有效数据
                        for (let i = 0, length = this.yearAndQuarterList.length; i < length; i++) {
                            arr[i] = {};
                            arr[i].code = this.yearAndQuarterList[i].code;
                            arr[i].text = this.yearAndQuarterList[i].name;
                            arr[i].complainQuarter = this.yearAndQuarterList[i].complainQuarter;
                        }
                        // 重新赋值下传组件数组
                        this.quarterList = this.quarterList.concat(arr);
                        this.newQuarterList.push(this.quarterList)
                        this.complainQuarter = this.newQuarterList[0][0].complainQuarter // 默认选择第一条数据的季度值

                        this.getQuarterValue(this.newQuarterList[0])
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },

            showQuarter () { // 唤起季度选择组件
                this.$refs.commonPickerQuarter.showPicker();
            },
            getQuarterValue (value) { // 选择季度
                this.quarterName = value[0].text
                this.yearQuarter = value[0].code
                this.year = value[0].code.substr(0, 4)// 取年
                this.quarter = value[0].code.substring(5)// 取季度
                this.complainQuarter = value[0].complainQuarter // 选择季度英文值
                this.getRankList(this.year, this.quarter)
            },
            // 排名列表
            getRankList (year, quarter) {
                api.getAssessScoreByQuarter({ year: year, quarter: quarter }).then(res => {
                    if (res.ret === 0) {
                        this.rankList = res.data.list
                        this.tabSwitch(this.tabIndex)
                    }
                })
            },
            sortList (list) { // 排序
                list.sort((x, y) => {
                    return x.ranking - y.ranking
                })
            },
            // tab切换过滤地区分类
            tabSwitch (index) {
                // this.$refs.drawer.switchTab(0)
                this.tabIndex = index
                let areaType = 0
                areaType = index + 1
                this.ranking = this.rankList.filter((item) => {
                    if (item.areaType === areaType) {
                        return item;
                    }
                })
                this.sortList(this.ranking)
            }

        },

        mounted () {
        },

        created () {
            this.getNotice()
        }

    }
</script>
<style scoped lang="less">
  .container {
    height: 100vh;
    background: rgba(251, 251, 251, 1);

    .pg-pd12 {
      padding:16px 12px 12px 12px;
    }
.noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 100px;
    }
    .tips {
      height: 48px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      color: #333333;
    }
 .notice-box1 {
      position: relative;
      display: flex;
      align-items: center;
      height: 30px;
      background: rgba(245, 245, 245, 1);
      border-radius: 3px;
      box-sizing: border-box;
      padding-left: 16px;
      margin-bottom: 26px;
      .left-text {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
        padding-right: 16px;
        margin-right: 16px;
        height: 30px;
        margin-top: 2px;
      }
      .swiper-box{
        flex: 1;
        height: 30px;
      }

    }

    .prov-total {
      margin-top: 24px;

      &-sel {
        display: flex;
        justify-content: space-between;

        .select {
          display: flex;
          align-items: center;

          span {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            padding-right: 4px;
          }

          .select-icon {
            width: 6px;
            height: 4px;
            background: url('../../assets/image/xiala.png') no-repeat;
            background-size: 6px 4px;
          }
        }

        .search {
          width: 15px;
          height: 15px;
          background: url('../../assets/image/sousuo.png') no-repeat;
          background-size: 15px 15px;
        }
      }

      .content {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        margin-top: 12px;

        &-item {
          display: flex;

          .total {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 24px 0;

            .title {
              display: flex;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 12px;

              .icon {
                width: 12px;
                height: 12px;
                margin-left: 4px;
              }
            }

            .num {
              font-size: 32px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
              line-height: 32px;
              margin-top: 9px;
            }

            .compare {
              display: flex;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 17px;
              margin-top: 8px;

              div:last-child {
                margin-left: 4px;
              }

              .bule {
                color: #2283E6;
              }

              .red {
                color: #FF4D4D;
              }

              .green {
                color: #36B374;
              }
            }
          }

          .total:nth-child(2) {
            border-left: solid 1px #EEEEEE;
          }
        }

        &-item:first-child {
          border-bottom: solid 1px #EEEEEE;
        }

        &-pd16 {
          padding: 16px 16px 12px 16px;

          .mt0 {
            margin-top: 0;
          }

          .mt13 {
            margin-top: 13px;
          }
        }
      }
    }
  }
</style>
